<div class="cfg-page lu-page">

  <!-- ── En-tête ───────────────────────────────────────────────── -->
  <div class="page-header">
    <div class="page-header__info">
      <h1 class="page-header__title">
        <i class="fal fa-users-cog"></i> {{ titrePage }}
      </h1>
      <p class="page-header__sub">{{ totalEnregistrements }} utilisateur(s) enregistré(s)</p>
    </div>
    <div class="header-actions">
      <button class="lu-btn-add" type="button" (click)="ajouterUtilisateur()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="15" height="15">
          <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
        Nouvel utilisateur
      </button>
    </div>
  </div>

  <!-- ── KPIs ──────────────────────────────────────────────────── -->
  <div class="kpi-row">
    <div class="kpi-card">
      <span class="kpi-val">{{ totalEnregistrements }}</span>
      <span class="kpi-label">Total</span>
    </div>
    <div class="kpi-card kpi-card--green">
      <span class="kpi-val">{{ nbActifs }}</span>
      <span class="kpi-label">Actifs</span>
    </div>
    <div class="kpi-card kpi-card--orange">
      <span class="kpi-val">{{ nbInactifs }}</span>
      <span class="kpi-label">Inactifs</span>
    </div>
    <div class="kpi-card kpi-card--blue">
      <span class="kpi-val">{{ nbLivreursScope }}</span>
      <span class="kpi-label">Livreurs</span>
    </div>
  </div>

  <!-- ── Filtres ───────────────────────────────────────────────── -->
  <div class="filtres-bar">
    <div class="filtre-search">
      <i class="fal fa-search"></i>
      <input type="text" placeholder="Nom, prénom, email, téléphone…" (keyup)="appliquerFiltre($event)" />
    </div>
  </div>

  <!-- ── Chargement ───────────────────────────────────────────── -->
  <div class="etat-centre" *ngIf="indicateurChargement">
    <div class="spinner"></div>
    <span>Chargement…</span>
  </div>

  <!-- ── Tableau ───────────────────────────────────────────────── -->
  <div class="table-wrapper lu-mat-wrapper" *ngIf="!indicateurChargement">

    <table mat-table [dataSource]="sourceDonnees" matSort class="lu-table">

      <!-- Nom -->
      <ng-container matColumnDef="nom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
        <td mat-cell *matCellDef="let user">
          <div class="lu-user-cell">
            <span class="lu-avatar">{{ (user.prenom || user.nom || 'U').charAt(0) }}</span>
            <div>
              <strong>{{ user.nom }}</strong>
              <small>{{ user.prenom }}</small>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Prénom -->
      <ng-container matColumnDef="prenom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Prénom</th>
        <td mat-cell *matCellDef="let user">{{ user.prenom || '—' }}</td>
      </ng-container>

      <!-- Email -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let user" class="lu-muted">{{ user.email || '—' }}</td>
      </ng-container>

      <!-- Téléphone -->
      <ng-container matColumnDef="telephone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Téléphone</th>
        <td mat-cell *matCellDef="let user">{{ user.telephone || user.contact || '—' }}</td>
      </ng-container>

      <!-- Type -->
      <ng-container matColumnDef="typeUtilisateur">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let user">{{ user.typeUtilisateurLibelle || user.typeUtilisateur || '—' }}</td>
      </ng-container>

      <!-- Zones (responsables de zone) -->
      <ng-container matColumnDef="zones">
        <th mat-header-cell *matHeaderCellDef>Zone(s) gérée(s)</th>
        <td mat-cell *matCellDef="let user">
          <div class="lu-zones-cell">
            <ng-container *ngIf="obtenirZonesTags(user).length > 0; else aucuneZone">
              <span class="lu-zone-tag" *ngFor="let z of obtenirZonesTags(user)">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                {{ z }}
              </span>
            </ng-container>
            <ng-template #aucuneZone><span class="lu-muted">—</span></ng-template>
          </div>
        </td>
      </ng-container>

      <!-- Rôle -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Rôle</th>
        <td mat-cell *matCellDef="let user">
          <span class="lu-role-badge lu-role-{{ (user.role || 'default') | lowercase }}">{{ user.role || '—' }}</span>
        </td>
      </ng-container>

      <!-- Note moyenne -->
      <ng-container matColumnDef="noteMoyenne">
        <th mat-header-cell *matHeaderCellDef>Note</th>
        <td mat-cell *matCellDef="let user">
          <ng-container *ngIf="estLivreur(user); else noRating">
            <span class="lu-rating" [class.lu-rating--empty]="obtenirNbAvisLivreur(user) === 0">
              <i class="fal fa-star"></i> {{ obtenirMoyenneLivreur(user) }}
            </span>
            <small class="lu-rating-count" *ngIf="obtenirNbAvisLivreur(user) > 0">
              ({{ obtenirNbAvisLivreur(user) }})
            </small>
          </ng-container>
          <ng-template #noRating><span class="lu-muted">—</span></ng-template>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="lu-th-actions">Actions</th>
        <td mat-cell *matCellDef="let user">
          <div class="actions-cell">

            <!-- Détail client (blue) -->
            <button *ngIf="estClient(user)"
              class="btn-action btn-action--blue"
              matTooltip="Fiche client" matTooltipPosition="above"
              (click)="voirDetailClient(user); $event.stopPropagation()">
              <i class="fal fa-address-card"></i>
            </button>

            <!-- Créer commande (teal) -->
            <button *ngIf="estClient(user)"
              class="btn-action btn-action--teal"
              matTooltip="Créer commande" matTooltipPosition="above"
              (click)="creerCommandePourClient(user); $event.stopPropagation()">
              <i class="fal fa-plus-circle"></i>
            </button>

            <!-- Voir (blue) -->
            <button class="btn-action btn-action--blue"
              matTooltip="Voir" matTooltipPosition="above"
              (click)="modifierUtilisateur(user.id); $event.stopPropagation()">
              <i class="fal fa-eye"></i>
            </button>

            <!-- Modifier (orange) -->
            <button class="btn-action btn-action--orange"
              matTooltip="Modifier" matTooltipPosition="above"
              (click)="modifierUtilisateur(user.id); $event.stopPropagation()">
              <i class="fal fa-pen"></i>
            </button>

            <!-- Supprimer (rouge) -->
            <button class="btn-action btn-action--danger"
              matTooltip="Supprimer" matTooltipPosition="above"
              (click)="supprimerUtilisateur(user); $event.stopPropagation()">
              <i class="fal fa-trash-alt"></i>
            </button>

          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colonnesAffichees"></tr>
      <tr mat-row *matRowDef="let row; columns: colonnesAffichees;"
          class="lu-row"
          (click)="modifierUtilisateur(row.id)"></tr>

      <!-- Aucune donnée -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell lu-no-data" [attr.colspan]="colonnesAffichees.length">
          <i class="fal fa-search" style="font-size:36px;color:#cbd5e0"></i>
          <p>Aucun utilisateur trouvé</p>
        </td>
      </tr>

    </table>

    <mat-paginator
      [pageSizeOptions]="[10, 25, 50, 100]"
      [pageSize]="10"
      showFirstLastButtons>
    </mat-paginator>

  </div>

</div>
